import { boolean, intersect, nullable, number, partial, string, struct } from 'io-ts/lib/Decoder';

import { DoorType } from '../../../ai/detection';
import { Line } from '../../../ui/geometry/Line';

/**
 * Represents an opening within a frame for HITL editing.
 *
 * Each opening is a geometry-based entity with its own:
 * - `id`: Unique identifier for the opening
 * - `height`: Height
 * - `isDoor`: Indicates if the opening is a door
 * - `correctedCenterLine`: Authoritative user-authored line.
 *
 * This allows individual openings to be selected, removed, and
 * manipulated independently.
 *
 * Width is never authored or persisted on an opening — Rome derives it from
 * the effective corrected-first center line and page scale wherever it is needed.
 */
export const Opening = intersect(
	struct({
		id: string,
		height: nullable(number),
		isDoor: boolean,
		correctedCenterLine: Line,
	})
)(
	partial({
		confidence: nullable(number),
		conflictGroupUuid: nullable(string),
		conflictGroupChooseOne: nullable(boolean),
		headHeight: nullable(number),
		startSegmentUuid: nullable(string),
		endSegmentUuid: nullable(string),
		doorType: nullable(DoorType),
	})
);
